export class App {
    constructor() {
        this.currentYear = (new Date()).getFullYear();
    }
}